<template>
  <VWidget :title="$t('Creation Source')">
    <div slot="widget-content">
      <v-layout
        wrap
        row
      >
        <v-flex
          xs12
          class="py-2 px-4 subheading">
          {{ $t('Created From:') }} <span class="font-weight-bold">{{ createdBy.from }}</span>
        </v-flex>
        <v-flex
          xs12
          class="py-2 px-4 subheading">
          {{ $t('Created By:') }} <span class="font-weight-bold">{{ createdBy.name }}</span>
        </v-flex>
      </v-layout>
    </div>
  </VWidget>
</template>

<script>
export default {
  name: 'OrderSingleCreatedBy',

  props: {
    createdBy: {
      type: Object,
      required: true
    }
  }
}
</script>
